// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2OuB7","date":"Table_date__Q_HbU","isNotNumeric":"Table_isNotNumeric__hOVWZ","tenDaysAgoDivisionLine":"Table_tenDaysAgoDivisionLine__3McC2"};